import {http} from './config/config-relation-register'

export default{
    listar:async(token,itens_pagina,pagina,filter)=>{
        if(itens_pagina,pagina){
            return  http.get('produtos?itens_pagina='+itens_pagina+'&pagina='+pagina+'&filter='+encodeURIComponent(filter),{
                headers:{
                    'Authorization':token
                }
            }) 
        }else{
            return  http.get('produtos',{
                headers:{
                    'Authorization':token
                }
            })
        }
    },
    salvar:(token, produto)=>{
        return http.post('produtos',produto,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idProduto)=>{
        return http.delete('produtos/'+idProduto,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, produto)=>{
        return http.put('produtos/'+produto.id_produto,produto,{
            headers:{
                'Authorization':token
            }
        })
    },
    additionalInformation:(token, id)=>{
        return http.get(`produtos/additional-information/${id}`, {
            headers:{
                'Authorization':token
            }
        })
       
    },
}